import { useNavigate, useSearchParams } from 'react-router-dom';
import { Selection } from 'src/projects/types/Selection';
import { useEffect } from 'react';

const parseSelection = (searchParams: URLSearchParams): Selection | null => {
    // @TODO add validation
    try {
        return JSON.parse(searchParams.get('s') || '{}');
    } catch (e) {
        // @TODO handle errors
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
};

export const SharePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const selection = parseSelection(searchParams);
    useEffect(() => {
        if (selection) {
            navigate({
                search: selection.searchQuery,
                pathname: selection.pathname,
            }, {
                state: selection.locationState,
                replace: true,
            });
        }
    }, [selection, navigate]);
    return selection === null ? 'Share link is malformed' : 'loading...';
};
